import { Ball, BallsWrapper, Label, ModalBody, ModalLoading, Wrapper } from "./Style";
import { style } from "./StyleType";

interface TmpLoadingCustomProps {
    label: string;
    loading: boolean;

}

export default function TmpLoadingCustom(props: TmpLoadingCustomProps) {


    // Passing style props to styled component
    Wrapper.defaultProps = style;
    BallsWrapper.defaultProps = style;
    Ball.defaultProps = style;
    Label.defaultProps = style;


    if(props.loading) {
        return (
            <div style={{ width: "100%", height: "100%", top: "0px", left: "0px", position: "absolute" }} >
                <div style={{ display: "flex", justifyContent: "center", alignItems: "ceneter", height: "100%" }} >
                    <ModalLoading>
                        <ModalBody>

                            <Wrapper>
                                <BallsWrapper>
                                    <Ball />
                                    <Ball />
                                    <Ball />
                                </BallsWrapper>
                                <Label>
                                    {props.label}
                                </Label>
                            </Wrapper>
                        </ModalBody>
                    </ModalLoading>
                </div>
            </div>
        );
    }else{
        return (
            <>
            </>
        )
    }

 }